import { useEffect, useRef, useState } from "react";
import "./NLAExpandable.scss";
import MultioptionButton from "../../../../../../components/Buttons/MultioptionButton";
import { Checkbox, FormControlLabel, FormGroup, Tooltip } from "@mui/material";
import Input from "../../../../../../components/Inputs/Input";
import HierarchyLines from "../../../../../../TestLine/HierarchyLines";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedNLA } from "../../../../../../redux/features/StoresModule/nlaReceivingSlice";
import { saveSerializedPartSvc } from "../../../../Services/receivingManagementService";
import { HTTP_RESPONSE_CODES } from "../../../../../../globals/globals";
import { useSnackBar } from "../../../../../../hooks/useSnackBar";
import { width } from "@mui/system";

export const NLAExpandable = ({
  node,
  tree,
  idx,
  isNodeOpen,
  showNode,
  toggleNode,
  quickSN = false,
  isPO = false,
  isOpenedProgrammatically = false,
  isEditMode = false,
  onCloseDetail = () => {},
  reloadNLAList,
}) => {
  const nodeRef = useRef(null);
  const [viewMode, setViewMode] = useState("none");
  const [merge, setMerge] = useState(!isPO);
  const [editNLA, setEditNLA] = useState(false);
  const [snValue, setSnValue] = useState("");
  const [positionValue, setPositionValue] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [version, setVersion] = useState(1);
  const { successMsg } = useSnackBar();
  const [quickEdition, setQuickEdition] = useState(false);
  const dispatch = useDispatch();
  const partSelected = useSelector(
    (state) => state.receivingNla.selectedNla ?? null
  );
  const directChildren = tree.filter((n) => n.parentNode === node.nodeId);
  const hasChildren = directChildren.length > 0;

  const siblings = tree.filter((n) => n.parentNode === node.parentNode);
  const siblingIndex = siblings.findIndex((n) => n.nodeId === node.nodeId);

  // const toggleChildren = (e) => {
  //   e.stopPropagation();
  //   setViewMode((prev) => (prev === "children" ? "none" : "children"));
  // };

  const handleSelectPart = (e) => {
    // e.stopPropagation();
    dispatch(setSelectedNLA(node));
  };

  const toggleDetail = () => {
    if (viewMode === "detail") {
      setViewMode("none");
      setEditNLA(false);
      onCloseDetail();
    } else {
      setViewMode("detail");
      handleSelectPart();
    }
  };

  const getParentSerializedPartId = () => {
    if (!node.parentNode) return null;

    const parent = tree.find((n) => n.nodeId === node.parentNode);

    return parent?.serializedPartId || null;
  };
  const savePartDetails = async (typeOfFinish) => {
    try {
      const parentSerializedPartId = getParentSerializedPartId();

      let body = {
        id : node.serializedPartId,
        partId: {
          id: node.partId,
          partNumber: node.partNumber,
          name: node.name,
          nla: true,
          autoassignSerialNumber: node.autoAssignSerialNumber,
        },
        serialNumber: snValue,
        // parentSerializedPartId: parentSerializedPartId,
        parentSerializedPartId: null,

        position: positionValue,
      };

      let request = await saveSerializedPartSvc(body);

      if (request.data.responseCode === HTTP_RESPONSE_CODES.CREATED) {
        if (typeOfFinish == "finish") {
          successMsg(
            "Serial Number Assigned",
            "The serial number has been assigned succesfully."
          );
          // toggleDetail();
          cancelEdition();
          reloadNLAList();
        } else {
          successMsg(
            "Serial Number Assigned",
            "The serial number has been assigned succesfully , you can continue editing."
          );
        }
        const updatedNode = {
          ...node,
          serialNumber: snValue,
          serializedPartId: request.data.load?.id, // Asumiendo que el response trae el ID
        };

        // dispatch(updateNodeInTree(updatedNode));
      }
    } catch (error) {
      console.error("Error en handleSaveSN:", error);
    }
  };

  const preloadForm = (data, quickSerial) => {
    if (
      data.serialNumber &&
      data.serialNumber !== "" &&
      data.serialNumber !== "--"
    ) {
      setSnValue(data.serialNumber);
    } else if (quickSerial && (quickEdition || editNLA)) {
      setSnValue("TMPSN - ");
    } else {
      setSnValue("");
    }

    setPositionValue(data.positions ? data.positions : "");
  };
  const cancelEdition = () => {
    setEditNLA(false);
    setQuickEdition(false);
    preloadForm(node, quickSN);
  };

  const multiOptionsBtn = [
    { label: "Save", icon: "icon-save", id: "save" },
    { label: "Save And Continue", icon: "icon-save", id: "save-and-continue" },
    { label: "Cancel", icon: "icon-cross", id: "cancel", type: "danger" },
  ];

  const buttonsCallback = {
    save: () => {
      savePartDetails("finish");
    },
    "save-and-continue": () => {
      savePartDetails("continue");
    },
    cancel: () => {
      cancelEdition();
    },
  };

  useEffect(() => {
    preloadForm(node, quickSN);
  }, [node, quickSN, editNLA, quickEdition]);

  useEffect(() => {
    if (isOpenedProgrammatically) {
      setViewMode("detail");
      if (isEditMode) {
        setEditNLA(true);
      }
    } else if (viewMode === "detail" && !isOpenedProgrammatically) {
      // Si estaba abierto pero ya no debería estarlo
      setViewMode("none");
      setEditNLA(false);
    }
  }, [isOpenedProgrammatically, isEditMode]);

  useEffect(() => {
    if (isOpenedProgrammatically && nodeRef.current) {
      setTimeout(() => {
        if (nodeRef.current) {
          nodeRef.current.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "start",
          });

          const container = document.querySelector(
            ".receiving-nla-modal-content-left-NLS-cont"
          );
          if (container) {
            const elementRect = nodeRef.current.getBoundingClientRect();
            const containerRect = container.getBoundingClientRect();

            if (
              elementRect.top < containerRect.top ||
              elementRect.bottom > containerRect.bottom
            ) {
              container.scrollTo({
                top: nodeRef.current.offsetTop - container.offsetTop - 50,
                behavior: "smooth",
              });
            }
          }
        }
      }, 100);
    }
  }, [isOpenedProgrammatically]);

  const updateSN = (e) => {
    const value = e.target.value;

    // 🚫 NO aplicar lógica de "TMPSN -" si ya tiene un serial number real
    if (
      node.serialNumber &&
      node.serialNumber !== "" &&
      node.serialNumber !== "--"
    ) {
      setSnValue(value); // Edición normal
      return;
    }

    // ✅ Aplicar lógica de "TMPSN -" solo si no tiene serial number real
    if (snValue.startsWith("TMPSN - ") && isEditing) {
      if (value.length < snValue.length) {
        if (value.length <= "TMPSN - ".length) {
          setSnValue("TMPSN - ");
        } else {
          setSnValue("TMPSN - " + value.substring("TMPSN - ".length));
        }
      } else {
        setSnValue("TMPSN - " + value.substring("TMPSN - ".length));
      }
    } else {
      setSnValue(value);
    }
  };

  const handleFocus = () => {
    setIsEditing(true);

    // 🚫 NO aplicar selección de "TMPSN -" si ya tiene serial number real
    if (
      node.serialNumber &&
      node.serialNumber !== "" &&
      node.serialNumber !== "--"
    ) {
      return;
    }

    // ✅ Aplicar selección solo si no tiene serial number real
    if (snValue === "TMPSN - ") {
      setTimeout(() => {
        const input = document.querySelector('input[label="SN"]');
        if (input) {
          input.setSelectionRange("TMPSN - ".length, "TMPSN - ".length);
        }
      }, 0);
    }
  };

  const handleBlur = () => {
    setIsEditing(false);

    if (
      node.serialNumber &&
      node.serialNumber !== "" &&
      node.serialNumber !== "--"
    ) {
      return;
    }

    // ✅ Aplicar lógica solo si no tiene serial number real
    if (snValue === "TMPSN - ") {
      setSnValue("TMPSN - ");
    }
  };

  const baseOffset = 2;
  const offset = baseOffset + node.level * 1.3;

  return (
    <section
      ref={nodeRef}
      className="NLA-expandable"
      style={{
        display: showNode(node) ? "flex" : "none",
      }}
    >
      <div
        className={`NLA-expandable-header ${
          partSelected?.nodeId == node?.nodeId
            ? "item-selected"
            : isNodeOpen(node) || viewMode == "detail"
            ? "item-open-header"
            : ""
        }`}
        onClick={handleSelectPart}
        style={{
          position: "relative",
          paddingLeft: node.level > 0 ? `${offset}rem` : "3rem",
          zIndex: `${node.level * 2}`,
        }}
      >
        {/* Líneas de jerarquía */}
        {node.level > 0 && (
          <HierarchyLines
            idx={siblingIndex}
            totalLength={siblings.length}
            depth={node.level}
            noChild={true}
            initialTop={62}
            zIndex={1}
          />
        )}

        {node.serializedPartId === null ? (
          <Tooltip title="This PN Doesn't Have a SN Assigned" arrow>
            <div className="receiving-nla-exp-icon-warning">
              <span class="icon-coloredwarning">
                <span class="path1"></span>
                <span class="path2"></span>
              </span>
            </div>
          </Tooltip>
        ) : null}

        {(node.level === 0 && isNodeOpen(node)) || node.level > 0 ? (
          <span
            className="NLA-exp-bulllet-hierarchy"
            style={{
              zIndex: `${node.level * 3}`,
              left:
                node.level > 0
                  ? `${offset + node.level + 3.6}%`
                  : `${offset + node.level + 3.4}%`,
              top: "50%",
              transform: "translate(-50%, -50%)",
              background:
                node.level === 0
                  ? "var(--hierarchy-0)"
                  : node.level === 1
                  ? "var(--hierarchy-1)"
                  : node.level === 2
                  ? "var(--hierarchy-2)"
                  : node.level === 3
                  ? "var(--hierarchy-3)"
                  : node.level === 4
                  ? "var(--hierarchy-4)"
                  : node.level === 5
                  ? "var(--hierarchy-5)"
                  : "var(--black-mid)",
              height: ".5rem",
              width: ".5rem",
            }}
          ></span>
        ) : null}

        <span className="col pn ellipsis">{node.partNumber || "--"}</span>
        {!quickEdition ? (
          <span className="col sn ellipsis">{snValue || "--"}</span>
        ) : (
          <Input
            placeholder={"SN"}
            style={{ width: "100%" }}
            value={snValue}
            onChange={updateSN}
            upperCase={true}
          ></Input>
        )}
        {!quickEdition ? (
          <span className="col vendor ellipsis">{positionValue || "--"}</span>
        ) : (
          <Input
            upperCase={true}
            placeholder={"Position"}
            style={{ width: "40%" }}
            value={positionValue}
            onChange={(e) => {
              setPositionValue(e.target.value);
            }}
          ></Input>
        )}

        <p className="nlaQty" style={{ position: "absolute", right: "30%" }}>
          {node.nlaQty ?? "--"}
        </p>
        <p className="etQty" style={{ position: "absolute", right: "18%" }}>
          {Array.isArray(node.et) ? node.et.length : "--"}
        </p>
        <Tooltip title={!quickEdition ? "quick edition" : "save"} arrow>
          {!quickEdition ? (
            <button
              style={{
                position: "absolute",
                top: "25%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                right: "11%",
                height: "1.5rem",
                width: "1.5rem",
                color: "var(--grey-300)",
                fontSize: "calc(--var(--p-size) + .1rem)",
                borderRadius: "var(--button-radius)",
                border: "none",
                background: "transparent",
                cursor: "pointer",
              }}
            >
              <i
                onClick={(e) => {
                  // e.stopPropagation();
                  setQuickEdition(!quickEdition);
                }}
                className="icon-edit"
                style={{}}
              ></i>
            </button>
          ) : (
            <button
              style={{
                position: "absolute",
                top: "25%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                right: "11%",
                height: "1.4rem",
                width: "1.4rem",
                color: "var(--white)",
                borderRadius: ".3rem",
                border: "none",
                background: "var(--black-mid)",
                cursor: "pointer",
              }}
              onClick={(e) => {
                e.stopPropagation();
                savePartDetails("finish");
              }}
            >
              <i
                className="icon-save"
                style={{
                  fontSize: ".7rem",
                }}
              ></i>
            </button>
          )}
        </Tooltip>
        <Tooltip
          title={!quickEdition ? "view general information" : "cancel"}
          arrow
        >
          {!quickEdition ? (
            <button
              style={{
                position: "absolute",
                top: "25%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                right: "6%",
                height: "1.5rem",
                width: "1.5rem",
                color: "var(--grey-300)",
                fontSize: "calc(--var(--p-size) + .1rem)",
                borderRadius: "var(--button-radius)",
                border: "none",
                background: "transparent",
                cursor: "pointer",
              }}
              onClick={toggleDetail}
            >
              <i
                className="icon-list"
                style={{
                  // position: "absolute",
                  // right: "6%",
                  // top: "30%",
                  fontSize: "calc(--var(--p-size) + .1rem)",
                }}
              ></i>
            </button>
          ) : (
            <button
              onClick={(e) => {
                e.stopPropagation();
                cancelEdition();
              }}
              style={{
                position: "absolute",
                top: "25%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                right: "6%",
                height: "1.5rem",
                width: "1.5rem",
                color: "var(--grey-300)",
                fontSize: "calc(--var(--p-size) + .1rem)",
                borderRadius: "var(--button-radius)",
                border: "none",
                background: "transparent",
                cursor: "pointer",
              }}
            >
              <i
                className="icon-cross"
                style={{
                  // position: "absolute",
                  // right: "6%",
                  // top: "30%",
                  color: "var(--grey-300)",
                  fontSize: ".7rem",
                }}
              ></i>
            </button>
          )}
        </Tooltip>

        {hasChildren && (
          <button
            className="NLA-expandable-toggle-btn"
            onClick={(e) => {
              e.stopPropagation();
              toggleNode(node);
            }}
          >
            <i
              className="icon-arrow-down"
              style={{
                rotate: isNodeOpen(node) ? "180deg" : "0deg",
              }}
            ></i>
          </button>
        )}
      </div>

      {/* DETAIL */}
      {viewMode === "detail" && (
        <div
          className="NLA-expandable-detail"
          style={{
            zIndex: `${node.level + 2 * 2}`,
          }}
        >
          <div>
            <p>Information</p>
            {editNLA ? (
              <MultioptionButton
                buttons={multiOptionsBtn}
                buttonCallbacks={buttonsCallback}
              />
            ) : (
              <button
                onClick={() => setEditNLA(!editNLA)}
                className="btn-receiving-edit-nla"
              >
                {" "}
                <i className="icon-edit"></i> Edit
              </button>
            )}
          </div>

          {/* {quickSN || node.serialNumber ? ( */}
          <Input
            disabled={!editNLA}
            label={"SN"}
            value={snValue}
            style={{ width: "calc(50% + .3rem)" }}
            onChange={updateSN}
            onFocus={handleFocus}
            onBlur={handleBlur}
            upperCase={true}
          />
          {/* ) : (
            ""
          )} */}

          <section>
            <div
              className={`merge-grn-receiving-cont ${
                isPO ? "" : merge ? "container-check-checked" : ""
              }`}
              style={{
                background:
                  isPO || (!editNLA && !merge)
                    ? "var(--disabled-input-bg)"
                    : !merge
                    ? "var(--white)"
                    : "",
              }}
            >
              <FormGroup>
                <FormControlLabel
                  disabled={!editNLA || isPO}
                  control={
                    <Checkbox
                      checked={merge}
                      onChange={(e) => {
                        setMerge(e.target.checked);
                      }}
                    />
                  }
                  label={
                    <p
                      style={{
                        color: "var(--black-mid)",
                        fontSize: "calc(var(--p-size) + .1rem)",
                      }}
                    >
                      Merge GRN
                    </p>
                  }
                />
              </FormGroup>
            </div>
            <Input
              style={{ flexGrow: "1" }}
              disabled={true}
              label={"Old Batch"}
              value={node?.new_batch ?? ""}
              upperCase={true}
            />
            <Input
              style={{ flexGrow: "1" }}
              disabled={true}
              label={"New Batch"}
              value={node?.new_batch ?? ""}
              upperCase={true}
            />
            <button>Historical Build</button>
          </section>
        </div>
      )}
    </section>
  );
};
